module.exports = __webpack_public_path__ + "static/media/vibepure-logo.63d707bc.jpg";